"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPostRequestSchema = void 0;
const yup_1 = require("yup");
const UserPostRequestSchema = (0, yup_1.object)().shape({
    email: (0, yup_1.string)().email().required(),
    firstName: (0, yup_1.string)().required(),
    lastName: (0, yup_1.string)().required(),
    groups: (0, yup_1.array)().min(1).required(),
    recordingFilter: (0, yup_1.object)().shape({
        caller: (0, yup_1.string)().nullable(),
        called: (0, yup_1.string)().nullable(),
        extensions: (0, yup_1.string)().nullable(),
    }),
});
exports.UserPostRequestSchema = UserPostRequestSchema;
